import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { FCM } from '@capacitor-community/fcm';
import { Platform, ToastController } from '@ionic/angular';
import {
    ActionPerformed,
    PushNotifications,
    PushNotificationSchema,
    Token,
} from '@capacitor/push-notifications';
// import { MessageApi } from '../api/message-api.service';
// import { SetNotiBadge } from '../store/actions/profile.action';
// import { setLocalStorage } from '../utils/storage';
// import { keyStorage } from '../constants/storage';
// import { ActionReducerMapType } from '../store/config-reducers';
import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
import { getLocalStorage } from '../utils/storage';
import { keyStorage } from '../constants/storage';
import { FCM_TOPIC } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FcmService {
    constructor(
        private router: Router,
        private platform: Platform,
        // private messageApi: MessageApi,
        // private store: Store<ActionReducerMapType>,
        private toastController: ToastController,
        private localNotifications: LocalNotifications
    ) {}

    initialization() {
        console.log('initialization fcm');
        if (this.platform.is('android') || this.platform.is('ios')) {
            this.register();
        }
    }

    private async register() {
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive === 'prompt') {
            PushNotifications.requestPermissions().then((result) => {
                if (result.receive === 'granted') {
                    PushNotifications.register(); // *Register the app to receive push notifications
                } else {
                    console.log('else');
                }
            });
        }
        

        // Enable the auto initialization of the library
        FCM.setAutoInit({ enabled: true }).then(() =>
            console.log('Auto init enabled')
        );

        // Check the auto initialization status
        FCM.isAutoInitEnabled().then((result) => {
            console.log(
                'Auto init is ' + (result.enabled ? 'enabled' : 'disabled')
            );
        });

        var channelId = '2045';
        var channelName = 'BMA Taxmap Verify';
        if (this.platform.is('android')) {
            
            PushNotifications.createChannel({
                id: channelId,
                name: channelName,
                importance: 4, // High (For Android 8 or newer)
                vibration: true,
            });
        }

        this.addListener();
    }

    addListener() {
        // On success, we should be able to receive notifications
        PushNotifications.addListener('registration', (token: Token) => {
            console.log('Push registration success, token: ' + token.value);
        });

        // Some issue with our setup and push will not work
        PushNotifications.addListener('registrationError', (error: any) => {
            console.log('Error on registration: ' + JSON.stringify(error));
        });

        // Show us the notification payload if the app is open on our device
        // * Called when the device receives a push notification.
        PushNotifications.addListener(
            'pushNotificationReceived',
            async (notification: PushNotificationSchema) => {
                console.log("===========>> pushNotificationReceived : ", notification);

                if(this.platform.is('android') || this.platform.is('ios')){
                    const toast = await this.toastController.create({
                        message: `<div>
                                    <span><strong>${notification.title}</strong></span><br/>
                                    <span>${notification.body}</span>
                                </div>`,
                        position: 'top',
                        duration: 5000,
                        color: 'light',
                        buttons: [
                            {
                                side: 'end',
                                text: 'View',
                                handler: () => {
                                    this.goToPage('/message');
                                },
                            },
                        ],
                    });
                    toast.present();
                }

                // if (this.platform.is('android')) {
                //     // Local notification
                //     this.localNotifications.schedule({
                //         id: parseInt(notification.id),
                //         title: notification.title,
                //         text: notification.body,
                //         foreground: true,
                //         channel: channelId,
                //         priority: 1, // High (Override importance for Android 7 and lower)
                //         launch: true,
                //     });

                //     this.localNotifications
                //         .on('click')
                //         .subscribe((notification) => {
                //             this.goToPage('/message');
                //         });
                // }

                // if (this.platform.is('ios')) {
                //     // Local notification
                //     this.localNotifications.schedule({
                //         id: parseInt(notification.id),
                //         title: notification.title,
                //         text: notification.body,
                //         foreground: true,
                //         priority: 1, // High (Override importance for Android 7 and lower)
                //         launch: true,
                //     });

                //     this.localNotifications
                //         .on('click')
                //         .subscribe((notification) => {
                //             this.goToPage('/message');
                //         });
                // }
            }
        );

        // Method called when tapping on a notification
        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            (notification: ActionPerformed) => {
                this.goToPage('/message');
            }
        );
    }

    subscribeTo() {
        console.log('Run subscribeTo');
        const userId = getLocalStorage(keyStorage.userId);

        //const topic: string = `th.co.got.bmaverify_${userId}_test`;
        const topic: string = FCM_TOPIC.replace('{userId}', userId);
        console.log('subscribeTo => topic:', topic);

        if (this.platform.is('android') || this.platform.is('ios')) {
            // now you can subscribe to a specific topic
            FCM.subscribeTo({ topic: topic })
                .then((r) => {
                    console.log(`subscribed to topic: '${topic}'`);
                    // alert(`subscribed to topic: '${topic}'`);
                })
                .catch((err) => console.log(err));
        }
    }

    unsubscribeFrom() {
        const userId = getLocalStorage(keyStorage.userId);

        //const topic: string = `th.co.got.bmaverify_${userId}_test`;
        const topic: string = FCM_TOPIC.replace('{userId}', userId);

        if (this.platform.is('android') || this.platform.is('ios')) {
            // Unsubscribe from a specific topic
            FCM.unsubscribeFrom({ topic: topic })
                .then(() => {
                    console.log(`unsubscribed from topic: '${topic}'`);
                    PushNotifications.removeAllListeners();
                })
                .catch((err) => console.log(err));
        }
    }

    goToPage(redirect: string) {
        this.router.navigateByUrl(redirect);
    }
}
